import AccountCreation from "@/components/signup/account-creation";
import { SignupBackgroundLayout } from "@/components/signup/layouts";
import { RovoDevAgentsLogo } from "@/components/signup/utils/get-rovo-dev-agents-logo";

import { GetStartedHeading } from "../../../components";

export const LoggedOutRovoDevStandard = () => {
    return (
        <SignupBackgroundLayout
            theme="green"
            ProductLogo={<RovoDevAgentsLogo />}
        >
            <GetStartedHeading productName="Rovo Dev" />
            <AccountCreation />
        </SignupBackgroundLayout>
    );
};
